module.exports = __webpack_public_path__ + "static/media/zombie.c0bb6fe2.svg";